import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 14 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-10%" }}
    transition={{ duration: 0.5, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SimBadge = ({ className = "" }) => (
  <span className={`inline-flex items-center gap-1.5 rounded-full bg-black/5 ring-1 ring-black/10 dark:bg-white/5 dark:ring-white/10 px-2.5 py-1 text-[11px] font-medium tracking-wide text-muted-foreground ${className}`}>
    <span className="size-1.5 rounded-full bg-amber-500" /> SIMULATED
  </span>
);
